// A public page (/verifyProvider) has no session, so the authorization of
// whoever sent the invite travels with the e-mail link as a single-use token.
// The page hands it back to keyon in this header, never in the form body:
// keyon logs CreateSubAccount's form body, and a header keeps the token out of
// that log. keyon refuses a malformed token outright (403 invite_required), so
// anything that is not 64 lowercase hex is not sent at all.
export const INVITE_HEADER = 'X-Pacmny-Invite';

const TOKEN_PATTERN = /^[a-f0-9]{64}$/;

/** {} unless token is 64 lowercase hex; else { 'X-Pacmny-Invite': token } */
export function inviteHeaders(token) {
  // `$` would also match before a trailing newline, so check the length too.
  if (typeof token !== 'string' || token.length !== 64 || !TOKEN_PATTERN.test(token)) {
    return {};
  }
  return { [INVITE_HEADER]: token };
}
